import { render } from "./nothing.vue?vue&type=template&id=844e9638"
import script from "./nothing.vue?vue&type=script&lang=js"
export * from "./nothing.vue?vue&type=script&lang=js"

import "./nothing.vue?vue&type=style&index=0&id=844e9638&lang=postcss"
script.render = render

export default script